import { Link } from "react-router-dom";
import "./body.css";

 function Body() {
  const handleClickFree = () => {
    alert("Contactez nous par mail: contact@wecheers.fr ou sur instagram");
  };

  return (
    <div>
      <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1" />

      <div className="landing">
        <div className="row">
          <p className="landingTitle">We<span className="mark">Cheers</span></p>
        </div>
        <div className="row">
          <div className="line"></div>
        </div>
        <div className="row" style={{flexWrap: "wrap"}}>
          <a className="boostCard">
            <div className="boostCardElements">
              <div className="row">
                <div className="cardImage lock"></div>
              </div>
              <div className="row">
                <div className="boostCardTitle">Accès <span className="mark">Limité</span></div>
              </div>
              <div className="row">
              <span className="boostCardSubTitle">Une publication par mois</span>
              </div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">Organisateur</div>
            </div>
            <div className="row">
              <div className="boostCardText">1 tous les deux mois</div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">Etablissement</div>
            </div>
            <div className="row">
              <div className="boostCardText">2 par mois</div>
            </div>
            <div className="row">
                <a className="buyButton" href="wecheers://"><p>Version gratuite restreinte</p></a>
            </div>
          </a>


          <a className="boostCard">
            <div className="boostCardElements">
              <div className="row">
                <div className="cardImage logo"></div>
              </div>
              <div className="row">
                <div className="boostCardTitle">Accès <span className="mark">Partenaire</span></div>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Publications d'évènements illimitées</span>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Mis en avant dans l'algorithme</span>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Notifications Relances</span>
              </div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">Organisateur</div>
            </div>
            <div className="row">
              <a href="https://buy.stripe.com/eVadUXbiJ2cYbJu14Z?locale=fr&__embed_source=buy_btn_1P0A42L0W270ohyAXjeLfvOn" className="boostCardText underline">à partir de 19€</a>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">Etablissement</div>
            </div>
            <div className="row">
            <a href="https://buy.stripe.com/eVaaIL5Yp4l69Bm6pg?locale=fr&__embed_source=buy_btn_1P0A5zL0W270ohyAYPut3WDJ" className="boostCardText underline">à partir de 29€</a>
            </div>
          </a>
          
        </div>

       
        <div className="row" style={{flexWrap: "wrap"}}>
          <a className="boostCard">
            <div className="boostCardElements">
              <div className="row">
                <div className="cardImage prime"></div>
              </div>
              <div className="row">
                <div className="boostCardTitle">Accès <span className="mark">Prime</span></div>
              </div>
              <div className="row">
              <span className="boostCardSubTitle">Propulsé en "A la une"</span>
              </div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">A la une d'une catégorie</div>
            </div>
            <div className="row">
              <div className="boostCardText">1 semaine / 2 semaines / 1 mois</div>
            </div>
            <div className="row">
            <div className="rowa">
              <a className="boostCardText underline">20€</a>
              <span  className="boostCardText">/</span>
              <a className="boostCardText underline">30€</a>
              <span  className="boostCardText">/</span>
              <a className="boostCardText underline">50€</a>
            </div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">A la une de toute l'application</div>
            </div>
            <div className="row">
              <div className="boostCardText">1 semaine / 2 semaines / 1 mois</div>
            </div>
            <div className="row">
              <div className="rowa">
                <a className="boostCardText underline">100€</a>
                <span  className="boostCardText">/</span>
                <a className="boostCardText underline">20€</a>
                <span  className="boostCardText">/</span>
                <a className="boostCardText underline">300€</a>
              </div>
            </div>
          </a>


          <a className="boostCard">
            <div className="boostCardElements">
              <div className="row">
                <div className="cardImage push"></div>
              </div>
              <div className="row">
                <div className="boostCardTitle">Notification <span className="mark">Push</span></div>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Attirez l'attention en un instant</span>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Une notification qui redirige instantanément tous les utilisateurs de lal ville vers votre établissement</span>
              </div>
              <div className="row">
                <span className="boostCardSubTitle">Notifications Relances</span>
              </div>
            </div>
            <div className="row">
            <div className="boostCardTextTitle">Notification</div>
            </div>
            <div className="row">
              <a href="https://buy.stripe.com/14kdUXfyZ9FqfZKdSa?locale=fr&__embed_source=buy_btn_1PF1vwL0W270ohyAc58mgBVf" className="boostCardText underline">50€</a>
            </div>
          </a>
          
        </div>
        <div className="bottom">
          <div className="contact">
            <p className="contactTitle">CONTACTEZ-NOUS</p>
            <p className="contactInfos">Antoine</p>
            <p className="contactInfos">contact@wecheers.fr</p>
            <p className="contactInfos">+33 6 77 81 58 47</p>
          </div>
        </div>
      </div>
  </div>
  );
}

export default Body;
